import * as React from 'react';
import { t } from '@moovly/i18n';
import useCurrentUser from '../../../hooks/useCurrentUser';

const WelcomeMessageContainer = () => {
  const { user } = useCurrentUser();
  const username = React.useMemo(() => {
    if (!!user?.personal_information?.first_name && !!user?.personal_information?.name) {
      return ((user.personal_information.first_name || '') + ' ' + (user.personal_information.name || '')).trim();
    }
    return '';
  }, [user]);

  return (
    <>
      <h3 className="text-center">{t('home.welcome.welcomeText', { username })}</h3>
      <p className="text-center"> {t('home.welcome.welcomeDescription')}</p>
    </>
  );
};

export default WelcomeMessageContainer;
